<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: 'app',
		mounted() {},
	};
</script>

<style lang="scss">

	@import "~@/assets/css/index.scss";

</style>



// WEBPACK FOOTER //
// App.vue?2e9cd5be